import React from 'react';

const heroBackground = process.env.PUBLIC_URL + '/assets/hero-background.png';

const Section: React.FC = () => {
  return (
    <section className="h-[400px] relative w-full">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute bg-slate-200 inset-0" />
        <img 
          src={heroBackground} 
          alt="Hero Background" 
          className="absolute max-w-none object-center object-contain opacity-20 w-full h-full"
        />
      </div>
    </section>
  );
};

export default Section;

